import { render } from "./AllLayout.vue?vue&type=template&id=61efcc56&scoped=true"
import script from "./AllLayout.vue?vue&type=script&lang=js"
export * from "./AllLayout.vue?vue&type=script&lang=js"

import "./AllLayout.vue?vue&type=style&index=0&id=61efcc56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61efcc56"]])

export default __exports__